module.exports = __webpack_public_path__ + "media/images/admin/icons/edit-2-dba1b42bb466bb06d702647839d28863.svg";